export enum RCumLaudeAccountAdditionalObjectKey {
	AUTORISATIES = 'autorisaties',
	LAATSTE_GEBRUIK = 'laatsteGebruik',
}
